import React from 'react';
import { ITask } from '../Interfaces/ITask';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Call, Email, ListAlt, Task } from '@mui/icons-material';
import { getPriorityColor, TaskPriorityChip } from './TaskPriorityChip';
import { getDeadlineColor, TaskDeadlineChip } from './TaskDeadlineChip';

interface IProps {
  task: ITask;
  setIdTask: React.Dispatch<React.SetStateAction<number | null>>;
}

export const CardTask: React.FC<IProps> = ({ task, setIdTask }) => {
  const handleOpen = () => setIdTask(task.idTask);

  return (
    <Card
      onClick={handleOpen}
      sx={{
        display: 'flex',
        borderRadius: 3,
        cursor: 'pointer',
        transition: '0.2s',
        '&:hover': {
          boxShadow: 6,
          transform: 'scale(1.01)',
        },
      }}
    >
      {/* STATUS-FARBBALKEN */}
      <Box sx={{ width: 6, bgcolor: getDeadlineColor(task) }} />

      <CardContent sx={{ width: '100%', p: 1.5 }}>
        {/* HEADER */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Box sx={{ color: getPriorityColor(task), mr: 1 }}>
            {task.idTaskType === 1 ? (
              <ListAlt />
            ) : task.idTaskType === 2 ? (
              <Call />
            ) : task.idTaskType === 3 ? (
              <Email />
            ) : (
              <Task />
            )}
          </Box>

          <Typography fontWeight={600} noWrap>
            {task.Title}
          </Typography>
        </Box>

        {/* INFOZEILE */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <TaskPriorityChip task={task} />
          <TaskDeadlineChip task={task} />
        </Box>
      </CardContent>
    </Card>
  );
};
